import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText,
  Paper
} from '@mui/material';
import PaletteIcon from '@mui/icons-material/Palette';
import ThemeSettings from './ThemeSettings';
import { useTheme } from '../context/ThemeContext';

function ConfigurationPage() {
  const [openThemeSettings, setOpenThemeSettings] = useState(false);
  const { setThemeColors } = useTheme();

  const handleSave = (colors) => {
    setThemeColors(colors);
    setOpenThemeSettings(false);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Configuración del Sistema
      </Typography>
      
      <Paper sx={{ mt: 2 }}>
        <List>
          <ListItem button onClick={() => setOpenThemeSettings(true)}>
            <ListItemIcon>
              <PaletteIcon />
            </ListItemIcon>
            <ListItemText 
              primary="Temas y Colores" 
              secondary="Personaliza los colores de la interfaz"
            />
          </ListItem>
        </List>
      </Paper>

      <ThemeSettings 
        open={openThemeSettings}
        onClose={() => setOpenThemeSettings(false)}
        onSave={handleSave}
      />
    </Box>
  );
}

export default ConfigurationPage; 